import React from "react";

import { useField } from "formik";

import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Rating, { RatingProps, IconContainerProps } from "@mui/material/Rating";
import { styled } from "@mui/material/styles";
import { Stack } from "@mui/system";

type FormikFormikRatingFace = {
  name: string;
  label?: string;
} & RatingProps;

const StyledRating = styled(Rating)(({ theme }) => ({
  "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
    color: theme.palette.action.disabled,
  },
  "& .MuiSvgIcon-root > label": {
    backgroundColor: "red",
  },
}));

const customIcons: Record<string, {
  icon: React.ReactElement;
  label: string;
}> = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon color="error" sx={{ fontSize: 52 }} />,
    label: "Very Dissatisfied",
  },
  2: {
    icon: <SentimentDissatisfiedIcon color="error" sx={{ fontSize: 52 }} />,
    label: "Dissatisfied",
  },
  3: {
    icon: <SentimentSatisfiedIcon color="warning" sx={{ fontSize: 52 }} />,
    label: "Neutral",
  },
  4: {
    icon: <SentimentSatisfiedAltIcon color="success" sx={{ fontSize: 52 }} />,
    label: "Satisfied",
  },
  5: {
    icon: <SentimentVerySatisfiedIcon color="success" sx={{ fontSize: 52 }} />,
    label: "Very Satisfied",
  },
};

export const FormikRatingFace = ({
  name,
  label,
  ...props
}: FormikFormikRatingFace) => {
  const [
    field,
    // meta,
    // helpers
  ] = useField(name);

  function IconContainer(props: IconContainerProps) {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value].icon}</span>;
  }

  return (
    <FormControl>
      {label && (
        <Stack marginBottom={1}>
          <FormLabel id={`formlabel-${name}`}>{label}</FormLabel>
        </Stack>
      )}
      <StyledRating
        {...field}
        {...props}
        name={field.name}
        IconContainerComponent={IconContainer}
        getLabelText={(value: number) => customIcons[value].label}
        highlightSelectedOnly
        sx={{
          justifyContent: {
            xs: "space-between",
            md: "flex-start",
          },
        }}
      />
    </FormControl>
  );
};
